<template>
    <div class="m-tags">
        <div
            v-for="tag in value"
            :key="tag.id"
            class="m-tags__tag"
        >
            {{ tag.name }}
            <a-button
                icon="CloseSmall"
                @click.prevent="removeElement(tag.id)"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [Array, Object],
            required: true
        }
    },
    methods: {
        removeElement(tagId) {
            const tagIndex = this.value.findIndex(tag => tag.id === tagId)
            this.value.splice(tagIndex, 1)
            this.$emit('input', this.value)
        }
    }
}
</script>